export default "__VITE_ASSET__q0VxsmCK__"